import { ArrowRight, ShieldCheck, Zap, Users, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { whatsappLink, COMPANY_NAME } from "@/lib/api";

const HERO_IMG =
  "https://images.unsplash.com/photo-1559136555-9303baea8ebd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxkaWdpdGFsJTIwZG9jdW1lbnRzJTIwc2VjdXJpdHklMjBzZWFsJTIwdHJ1c3QlMjBjdXN0b21lciUyMHN1cHBvcnQlMjBtb2Rlcm4lMjBvZmZpY2V8ZW58MHx8fHwxNzkxMzc5NzAxfDA&ixlib=rb-4.1.0&q=85";

export default function Hero({ onStart }) {
  return (
    <section id="top" className="relative overflow-hidden bg-gradient-to-br from-[#0F294A] via-[#122f54] to-indigo-950 text-white pt-28 pb-20 lg:pt-36 lg:pb-28">
      <div className="absolute inset-0 opacity-[0.07]" style={{ backgroundImage: "radial-gradient(circle at 1px 1px, white 1px, transparent 0)", backgroundSize: "28px 28px" }} />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8 items-center relative">
        <div className="lg:col-span-7 fade-up">
          <span className="inline-flex items-center gap-2 rounded-full bg-emerald-500/15 border border-emerald-400/30 px-3 py-1.5 text-xs font-semibold text-emerald-300 mb-5">
            <span className="relative flex h-2 w-2"><span className="pulse-ring absolute inline-flex h-2 w-2 rounded-full" /><span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-400" /></span>
            Atendimento online agora
          </span>
          <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold leading-[1.12] tracking-tight">
            Regularize seu <span className="text-emerald-400">MEI, CPF</span> e documentos sem burocracia
          </h1>
          <p className="mt-5 text-lg sm:text-xl text-slate-300 leading-relaxed max-w-xl">
            Atendimento rápido, seguro e descomplicado. Acompanhamento via WhatsApp com especialistas em assessoria administrativa.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <Button data-testid="hero-start-button" onClick={onStart} size="lg" className="bg-emerald-600 hover:bg-emerald-700 text-white rounded-full h-14 px-8 text-base font-bold gap-2 shadow-lg shadow-emerald-900/30">
              Iniciar Atendimento <ArrowRight className="h-5 w-5" />
            </Button>
            <a href={whatsappLink(`Olá! Preciso de ajuda com os serviços da ${COMPANY_NAME}.`)} target="_blank" rel="noreferrer">
              <Button data-testid="hero-whatsapp-button" size="lg" variant="outline" className="w-full sm:w-auto rounded-full h-14 px-8 text-base font-semibold border-white/30 bg-white/5 text-white hover:bg-white/15 gap-2">
                <MessageCircle className="h-5 w-5" /> Falar no WhatsApp
              </Button>
            </a>
          </div>

          <div className="mt-10 grid grid-cols-3 gap-4 max-w-lg">
            {[
              { icon: ShieldCheck, label: "100% Seguro", sub: "Dados protegidos (LGPD)" },
              { icon: Zap, label: "Pix Imediato", sub: "Aprovação na hora" },
              { icon: Users, label: "+45 mil", sub: "atendimentos" },
            ].map((b) => (
              <div key={b.label} className="text-center sm:text-left">
                <b.icon className="h-6 w-6 text-emerald-400 mx-auto sm:mx-0" />
                <p className="mt-2 font-bold text-sm">{b.label}</p>
                <p className="text-xs text-slate-400">{b.sub}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-5 fade-up" style={{ animationDelay: "0.15s" }}>
          <div className="relative">
            <div className="absolute -inset-3 bg-emerald-500/20 blur-2xl rounded-3xl" />
            <img src={HERO_IMG} alt="Atendimento de assessoria administrativa" className="relative rounded-2xl shadow-2xl w-full h-[340px] lg:h-[420px] object-cover border border-white/10" />
            <div className="absolute -bottom-5 -left-3 sm:left-4 bg-white text-slate-900 rounded-xl shadow-xl p-4 flex items-center gap-3 border border-slate-100">
              <span className="grid place-items-center h-11 w-11 rounded-full bg-emerald-100 text-emerald-600"><ShieldCheck className="h-6 w-6" /></span>
              <div>
                <p className="text-sm font-bold leading-tight">Processo Regularizado</p>
                <p className="text-xs text-slate-500">Documento enviado no WhatsApp</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
